import React, { useState } from 'react';
import CardMain from '$/components/Interactions/cards/CardMain';
import { useCardContext } from '$/components/Interactions/cards/CardContext';
import { InteractionDisplayState } from '../InteractionInfo';
import Textarea from '$/components/ui/Input/Basics/Textarea';
import { Trans, t } from '@lingui/macro';
import { useFormContext } from 'react-hook-form';
import Form from '$/components/ui/Form';

const QuestionCard: React.FC = React.memo((): JSX.Element | null => {
  const [isDisabled, setIsDisabled] = useState(true);
  const { watch } = useFormContext();
  const { interaction, displayState } = useCardContext();

  const answerCard: string = watch('stringAnswer') ?? interaction.reaction?.stringAnswer ?? '';

  React.useEffect(() => {
    const disabled = !answerCard?.trim().length;
    setIsDisabled(disabled);
  }, [answerCard]);

  if (!interaction.details) {
    return null;
  }

  switch (displayState) {
    case InteractionDisplayState.Submitted:
    case InteractionDisplayState.Result:
      return (
        <>
          <CardMain.SubmitBubble>
            <CardMain.IconThanks />
            <CardMain.Jumbotron>
              <Trans>Thanks!</Trans>
            </CardMain.Jumbotron>
          </CardMain.SubmitBubble>
        </>
      );

    case InteractionDisplayState.Normal:
      return (
        <>
          <Form.Field
            name='stringAnswer'
            className='w-full'
            component={<Textarea placeholder={`${t`Your answer here`}...`} maxLength={512} />}
          />

          <CardMain.SubmitButton disabled={isDisabled}>
            {interaction.details.buttonText || t`Submit`}
          </CardMain.SubmitButton>
        </>
      );
  }

  return null;
});

export default QuestionCard;
